import { render, staticRenderFns } from "./OrdersTable.vue?vue&type=template&id=f9cd8434"
import script from "./OrdersTable.vue?vue&type=script&lang=js"
export * from "./OrdersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports